"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFooter = void 0;
var _react = require("react");
var _contexts = require("../contexts");
const useFooter = () => (0, _react.useContext)(_contexts.footerContext);
exports.useFooter = useFooter;
